import { Tenant } from "@models";
import { favoriteService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";

export default class FavoriteStore {
  favorites: Tenant[] = [];
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAll = async () => {
    this.loading = true;
    try {
      const response = await favoriteService.getAll();
      runInAction(() => {
        this.favorites = response;
        this.loading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  toggle = async (tenantId: number) => {
    const existing = this.favorites.find((f) => f.id === tenantId);
    const prevFavorites = [...this.favorites];

    // Optimistic update
    if (existing) {
      this.favorites = this.favorites.filter((f) => f.id !== tenantId);
    } else {
      this.favorites = [...this.favorites, { id: tenantId } as Tenant];
    }

    try {
      const added = await favoriteService.toggle(tenantId);
      if (added) {
        await this.getAll();
      }
      return added;
    } catch (error) {
      console.error(error);
      // Revert on error
      runInAction(() => {
        this.favorites = prevFavorites;
      });
      return !!existing;
    }
  };
}
